import { useState, useEffect } from 'react';
import { getNetworkLogoUrl, getNetworkColor } from '../../lib/networkLogos';

interface NetworkIconProps {
  networkCode: string;
  size?: string;
  className?: string;
}

export function NetworkIcon({ networkCode, size = 'w-8 h-8', className = '' }: NetworkIconProps) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
  const logoUrl = getNetworkLogoUrl(networkCode);
  const hasLogo = !!logoUrl;

  // Reset states when network changes
  useEffect(() => {
    setImageLoaded(false);
    setImageError(false);
  }, [networkCode, logoUrl]);

  return (
    <div
      className={`${size} ${className} rounded-full flex items-center justify-center font-bold text-xs overflow-hidden transition-all duration-200`}
      style={{
        background: (!hasLogo || !imageLoaded || imageError) ? getNetworkColor(networkCode) : '#FFFFFF',
        padding: (hasLogo && imageLoaded && !imageError) ? '4px' : '0',
      }}
    >
      {hasLogo && !imageError ? (
        <img
          src={logoUrl}
          alt={networkCode}
          className={`w-full h-full object-contain transition-opacity duration-200 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageError(true)}
        />
      ) : null}
      {(!hasLogo || !imageLoaded || imageError) && (
        <span className="text-white text-[8px]">{networkCode.slice(0, 3)}</span>
      )}
    </div>
  );
}
